<template lang="pug">
el-card(v-show="shouldShow", v-loading.body="loading")
  .cf(slot="header")
    h2 Литература
  el-form(label-position="top", ref="form", :model="record", :rules="rules")
    el-row
      el-col(:sm="12")
        el-form-item(prop="title", label="Заглавие")
          el-input(v-model="record.title")
      el-col(:sm="4")
        el-form-item(prop="isbn", label="ISBN")
          el-input(v-model="record.isbn")
      el-col(:sm="4")
        el-form-item(prop="edition", label="Издание")
          el-input(v-model.number="record.edition", type="number")
      el-col(:sm="4")
        el-form-item(prop="year", label="Година")
          el-input(v-model.number="record.year", type="number")
    el-row
      el-col(:sm="4")
        el-form-item(v-if="!record.id", prop="numAll", label="Наличност")
          el-input(v-model.number="record.numAll", type="number")
        div(v-else)
          el-button(type="primary", @click="onAdd") Добави към наличност
          p Общо: {{ record.numAll }}
          p Продажби: {{ record.numSold }}
          p Наличност: {{ record.numAll - record.numSold }}
      el-col(:sm="4", :offset="12")
        el-form-item(prop="discount", label="Отстъпка")
          el-input(v-model.number="record.discount", type="number")
            template(slot="append") %
      el-col(:sm="4")
        el-form-item(prop="price", label="Цена")
          el-input(v-model.number="record.price", type="number")
            template(slot="append") лв.

    .form-actions.cf
      el-button.fl(type="text", icon="arrow-left", @click="$router.push(url)") Назад към списъка
      el-button.fr(type="primary", @click="onSubmit") {{ isNew ? 'Създай' : 'Запази' }}
      el-button.fr(v-if="record.id", type="danger", @click="onDelete") Изтрий

  subject-history(v-if="!isNew", :filters="{type: 1030, LiteratureId: record.id}")
  //- payment-history(v-if="!isNew", :filters="{subject: 1030, LiteratureId: record.id}")
</template>

<script>
import formMixin from '../mixins/formMixin.js'
import SubjectHistory from './SubjectHistory'
import PaymentHistory from './PaymentHistory'

export default {
  name: 'LiteratureForm',
  mixins: [formMixin],
  props: {},
  data () {
    return {
      apiUrl: '/literature',
      url: '/literature',
      loading: true,
      record: {
        id: null,
        title: '',
        isbn: '',
        edition: '',
        year: null,
        discount: 0,
        price: null,
        numAll: null,
        numSold: null
      },
      rules: {
        title: {required: true, message: 'Полето е задължително'},
        isbn: {required: true, type: 'string', min: 10, message: 'Полето е задължително поне 10 символа'},
        edition: {required: true, type: 'integer', message: 'Полето е задължително'},
        year: {required: true, type: 'integer', min: 1900, max: 2030, message: 'Невалидна година (1900-2030)'},
        numAll: {required: true, type: 'integer', message: 'Полето е задължително'},
        discount: {required: true, type: 'integer', min: 0, max: 100, message: 'Число от 0 до 100'},
        price: {required: true, type: 'number', min: 0, message: 'Невалидна цена'},
      },
      added: null
    }
  },
  methods: {
    onAdd () {
      this.$prompt('Добавяне към текущата наличност', '', {
        confirmButtonText: 'Добави',
        cancelButtonText: 'Откажи',
        inputPattern: /^-?\d+$/,
        inputErrorMessage: 'Невалидно число'
      }).then(result => {
        this.record.numAll = this.record.numAll + parseInt(result.value)
        this.$message({message: `Запишете за да потвърдите добавянето на ${result.value} бройки.`, type: 'warning'})
      }).catch(() => {

      })
    },
  },
  components: {
    SubjectHistory,
    PaymentHistory
  }
}
</script>